//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMessage } from 'vuelidate-messages';

const formMessages = {
  required: function () {
    return this.$i18n.t('error.required');
  },
  minLength: function ({ $params }) {
    return this.$i18n.t('error.must_be_at_lease_{count}_characters', { count: $params.minLength.min });
  },
  maxLength: function ({ $params }) {
    return this.$i18n.t('error.must_be_less_than_{count}_characters', { count: $params.maxLength.max });
  },
};

export default {
  name: 'base-textarea',
  props: {
    id: String,
    value: {
      type: String,
      default: '',
    },
    v: {
      type: Object,
    },
    name: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    mask: {
      type: [String, Array],
      required: false,
      default: '',
    },
    rows: {
      type: [String, Number],
      default: 5,
    },
    customClass: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    showErrorMsg: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isRequired() {
      return _.has(this.v, '$params.required');
    },
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    getValidationMessage: validationMessage(formMessages),
  },
};
